
import { Component, Input, Output, EventEmitter }  from '@angular/core';
import { MouseEvent } from '@agm/core';

// just an interface for type safety.
interface Marker {
	lat: number;
	lon: number;
	label?: string;
	draggable?: boolean;
}

@Component({
	selector: 'google-map',
	templateUrl: "./google-map.html",
	styles: [require("./google-map.scss")]
})

export class GoogleMapComponent {
	private latMapCenter: number = 48.7960447;
	private	lonMapCenter: number = 9.0095706;

	private marker: Marker = {
		lat: this.latMapCenter,
		lon: this.lonMapCenter,
		draggable: true
	}

	@Input() set lat(lat: string) {
		if (lat) {
			this.marker.lat = parseFloat(lat)
			this.latMapCenter = parseFloat(lat)
		}
	}
	@Input() set lon(lon: string) {
		if (lon) {
			this.marker.lon = parseFloat(lon)
			this.lonMapCenter = parseFloat(lon)
		}
	}
	@Output() latChange: EventEmitter<number> = new EventEmitter<number>();
	@Output() lonChange: EventEmitter<number> = new EventEmitter<number>();

	zoom: number = 15;



	markerDragEnd(m: Marker, event: MouseEvent) {
		this.latChange.emit(event.coords.lat)
		this.lonChange.emit(event.coords.lng)
	}




}





// WEBPACK FOOTER //
// ./src/app/ui-helper/google-map/google-map.component.ts